import Vue from 'vue';

export default {
  // 获取我的转出项目列表
  getRollOutProjectList (pageNum, pageSize) {
    return Vue.axios.get('/api/v1.0/chanquan/center/getProjectListByUser/' + pageNum + '/' + pageSize);
  },
  // 获取我的批量转出项目列表
  getBatchOutProjectList (pageNum, pageSize) {
    return Vue.axios.get('/api/v1.0/chanquan/project/batch/pageBatchProject?pageNum=' + pageNum + '&pageSize=' + pageSize);
  },
  // 获取我的批量转出项目详情
  getBatchProject (id) {
    return Vue.axios.get('/api/v1.0/chanquan/project/batch/getBatchProject?id=' + id);
  },
  // 驳回公告
  rejectAnnouncement (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/center/rejectAnnouncement', payload);
  },
  // 确认公告-校验
  checkConfirmProjec (projectId) {
    return Vue.axios.get(`/api/v1.0/chanquan/center/checkProjectNoticeStartTimeById/${projectId}`);
  },
  // 我的转出项目详情
  confirmProjectById (projectId) {
    return Vue.axios.get('/api/v1.0/chanquan/center/confirmProjectById/' + projectId);
  },
  // 我的转出项目详情
  getRollOutProjectDetail (params) {
    return Vue.axios.get('/api/v1.0/chanquan/project/echo', { params });
  },
  // 立即报名保存的接口
  atonceSign (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/signUpSave', payload);
  },

  // 获取我的报名流转
  getSignUpProjectList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/bid/selectTransferSignList', params);
  },

  // 查询支付保证金详情
  getOrderDetaiByDeposit (params) {
    return Vue.axios.post('/api/v1.0/chanquan/bid/getOrderDetaiByDeposit', params);
  },

  // 支付保证金
  paymentBid (body) {
    return Vue.axios.post('/api/v1.0/chanquan/bid/paymentFee', body);
  },

  // 获取流转报名详情
  getSignUpProjectDetail (bidId) {
    return Vue.axios.get('/api/v1.0/chanquan/bid/selectTransferSignDetails/' + bidId);
  },

  getProjectFileList (id) {
    return Vue.axios.get('/api/v1.0/chanquan/center/getProjectFileList/' + id);
  },
  // 竞价列表
  selectBidList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/center/project/selectBidTransferTargetPageList', params);
  },
  // 我的流转 - 处理
  selectDealResults (id) {
    return Vue.axios.get('/api/v1.0/chanquan/project/selectDealResults/' + id);
  },
  // 创建合同页面的 回显数据
  toCreateContract (projectId, userId, projectType) {
    return Vue.axios.get('/api/v1.0/chanquan/project/toCreateContract/' + projectId + '/' + userId + '/' + projectType);
  },
  // 创建合同提交
  createContract (params) {
    return Vue.axios.post('/api/v1.0/chanquan/center/createContract', params);
  },
  // 林地预览合同 传userId是乙方，不传是甲方
  displayWoodsContract (projectId, projectType, userId, type) {
    if (type === '1') {
      return Vue.axios.get('/api/v1.0/chanquan/center/getContractDetailsResult/' + projectId + '/' + projectType + '?userId=' + userId);
    } else {
      return Vue.axios.get('/api/v1.0/chanquan/center/getContractDetailsResult/' + projectId + '/' + projectType);
    }
  },
  // 转让-承包流转项目
  getContractedProjectList (pageNum, pageSize) {
    return Vue.axios.get('/api/v1.0/chanquan/center/contractProjectList/' + pageNum + '/' + pageSize);
  },
  // 个人中心-转让-确认成交信息回显
  getConfirmDealBookInfo (params) {
    return Vue.axios.post('/api/v1.0/chanquan/center/echoProjectConfirmDealBook', params);
  },
  // 转让-确认成交书
  confirmDealBook (projectId, bidId) {
    return Vue.axios.get('/api/v1.0/chanquan/center/confirmTransactionBook/' + projectId + '/' + bidId);
  },
  // 下载合同
  downloadContractDemo (projectType, projectSubType, tradeType) {
    return Vue.axios.get('/api/v1.0/chanquan/center/project/downloadContractDemo?projectType=' + projectType + '&projectSubType=' + projectSubType + '&tradeType=' + tradeType);
  },
  // 去竞价
  getEjyToken (bidId) {
    return Vue.axios.get('/api/v1.0/chanquan/user/getBiddingToken/' + bidId);
  },
  // 个人中心-转让-签署合同
  applySignContract (params) {
    return Vue.axios.post('/api/v1.0/chanquan/center/project/applySignContract', params);
  },
  // // 个人中心-转让-确认合同
  // confirmContract (projectId, confirmStatus) {
  //   return Vue.axios.get('/api/v1.0/chanquan/center/confirmContract?projectId=' + projectId + '&confirmStatus=' + confirmStatus);
  // },
  // 个人中心-转让-确认合同
  confirmContract (params) {
    return Vue.axios.get('/api/v1.0/chanquan/center/confirmContract', { params });
  },
  // 确认合同回显接口
  confirmContractDetails (projectId) {
    return Vue.axios.get('/api/v1.0/chanquan/center/confirmContractDetails/' + projectId);
  },
  // 项目文件
  projectFileDownload (id) {
    return Vue.axios.get('/api/v1.0/chanquan/center/projectFileDownload?id=' + id + '&type=1');
  },
  // 获取支付合同款详情
  getContractPaymentDetail (bidId) {
    return Vue.axios.get('/api/v1.0/chanquan/project/selectProjectContractFundDetail/' + bidId);
  },
  // 支付合同款
  contractPayment (params) {
    return Vue.axios.post('/api/v1.0/chanquan/project/payContract', params);
  },
  // 审核成交人回显信息(审核受让人详情)
  getSignUserInfo (bidId, userId) {
    return Vue.axios.get('/api/v1.0/chanquan/bid/getBidUserInfoById/' + bidId + '/' + userId);
  },
  // 审批报名人资质
  approveSignQualification (params) {
    return Vue.axios.post('/api/v1.0/chanquan/bid/approveProjectSignQualification', params);
  },
  // 拒绝成交原因
  abandonTransactionBook (params) {
    return Vue.axios.post('/api/v1.0/chanquan/center/abandonTransactionBook', params);
  },
  // 报名流转标的
  selectDictListByExcludeDictId (params) {
    return Vue.axios.post('/api/v1.0/chanquan/dictionary/selectDictListByExcludeDictId', params);
  },
  // 项目结算
  tradeProjectSettlement (bidId) {
    return Vue.axios.get('/api/v1.0/chanquan/project/tradeProjectSettlement/' + bidId);
  },
  // 上传批量项目公告照片
  uploadPublicityPicture (params) {
    return Vue.axios.post('/api/v1.0/chanquan/project/batch/uploadPublicityPicture', params);
  },
  // 撤销报名
  revocationSignUp (bidId) {
    return Vue.axios.get('/api/v1.0/chanquan/bid/revocationSignUp', { params: { bidId } });
  }
};
